import { configureCartStore, type CartItem, type CartReconciliationResult } from "@ecommerce/cart";
import { createCartService } from "@ecommerce/http-services";
import { productQuantity } from "@ecommerce/shared-utils";
import { httpClient } from "../http/client";
import { AppConfigFields } from "../types/appConfigEntities";

const cartService = createCartService(httpClient);
const minimumPurchase = window.APP_CONFIG?.[AppConfigFields.MinimumPurchaseQuantity] || 1;

const reconcileCart = async (items: readonly CartItem[]): Promise<CartReconciliationResult> => {
    const response = await cartService.reconcile({
        lines: items.map((item) => ({
            productId: item.idProduct,
            variantId: item.idProductVariant,
            quantity: item.quantity,
            minimumQuantity: productQuantity.getMinimum({
                cantDecimal: item.cantDecimal,
                storefrontMinimum: minimumPurchase,
            }),
        })),
    });

    return {
        pricingContext: response.pricingContext,
        items: response.lines
            .filter((line) => line.available)
            .map((line) => ({
                idProduct: line.productId,
                idProductVariant: line.variantId,
                name: line.name,
                price: line.unitPrice,
                quantity: line.acceptedQuantity,
                image: line.image,
                stock: line.stock ?? 0,
                unitMeasureCode: line.unitMeasureCode,
                unitLabel: line.unitLabel,
                cantDecimal: line.cantDecimal,
                minimumQuantity: line.minimumQuantity,
                attributes: line.attributes,
            })),
        changes: response.changes,
    };
};

let configured = false;

export const configureStorefrontCart = (): void => {
    if (configured) return;

    configureCartStore({
        concurrencyMode: "locked",
        reconcileCart,
    });
    configured = true;
};
